// @ts-nocheck
// import constants from "@store/constants";
// import fieldDefinitionBuilder from "@store/Framework/Features/FieldDefinitionBuilder/fieldDefinitionBuilder"; // Store Custom Code
// import { FieldDefinitionBuilderOptions } from "@store/Framework/Features/FieldDefinitionBuilder/FieldDefinitionBuilderTypes"; // Store Custom Code
// import { responsiveCss } from "@store/Framework/Features/FieldDefinitionBuilder/Utilities/responsiveCss"; // Store Custom Code
import { FoundationFieldDefinition } from "@store/Framework/Types/FoundationFieldDefinition";
// import Typography, { TypographyProps } from "@store/MobiusOverrides/Typography/Typography"; // Store Custom Code
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getCurrentPage } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import PageBreadcrumbs from "@insite/content-library/Components/PageBreadcrumbs";
import getColor from "@insite/mobius/utilities/getColor";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import breakpoint from "@toolkit/Framework/Common/Utilities/breakpoint";
import getWidgetComponent from "@toolkit/Framework/Common/Utilities/getWidgetComponent";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
import { siteWidthStyles } from "@toolkit/Themes/common/mixins";
import * as React from "react";
import { connect } from "react-redux";
import { css } from "styled-components";

/* Store Custom Code - Start */
import constants from "@store/constants";
import fieldDefinitionBuilder from "@store/Framework/Features/FieldDefinitionBuilder/fieldDefinitionBuilder";
import { FieldDefinitionBuilderOptions } from "@store/Framework/Features/FieldDefinitionBuilder/FieldDefinitionBuilderTypes";
import { responsiveCss } from "@store/Framework/Features/FieldDefinitionBuilder/Utilities/responsiveCss";
import Typography, { TypographyProps } from "@store/MobiusOverrides/Typography/Typography";
/* Store Custom Code - End */

const BlogSearch = getWidgetComponent("Blog/BlogSearch");
const StyledContainer = getWidgetComponent("StyledContainer");

const mapStateToProps = (state: ApplicationState) => {
    return {
        page: getCurrentPage(state),
        isHomePage: getCurrentPage(state).type === constants.pageType.blogHome,
    };
};

type Props = WidgetProps &
    ReturnType<typeof mapStateToProps> & {
        fields: {
            positionX: number;
            positionY: number;
        } & FieldDefinitionBuilderOptions;
    };

export interface BlogTitleStyles {
    overlayWrapper?: InjectableCss;
    title?: TypographyProps;
    contentWrapper?: InjectableCss;
}

export const blogTitleStyles: BlogTitleStyles = {
    overlayWrapper: {
        css: css``,
    },
    title: {
        variant: "h1" /* Store Custom Code */,
        as: "h1",
        border: {
            align: "flex-start",
        },
        css: css`
            color: ${getColor("common.background")};
            max-width: ${pxToRem(720)};

            ${breakpoint("xs", "down")} {
                align-items: center;
            }
        `,
    },
    contentWrapper: {
        css: css`
            width: 100%;
            ${siteWidthStyles()}
        `,
    },
};

const styles = blogTitleStyles;

const BlogHeader: React.FC<Props> = ({ page, fields }) => {
    if (!page) {
        return null;
    }

    const wrapperStyles = {
        css: responsiveCss(
            fields,
            field => css`
                height: 35vh;
                background-image: url(${page.fields.openGraphImage});
                background-size: cover;
                background-repeat: no-repeat;
                /* Store Custom Code */
                background-position: ${field.positionX || 0}% ${field.positionY || 0}%;

                ${breakpoint("md")} {
                    height: 40vh;
                }
            `,
        ),
    };

    const overlayWrapperStyles = {
        css: css`
            height: 100%;
            display: flex;
            align-items: center;
            justify-content: center;
            background-color: ${getColor("secondary")}80; /* Store Custom Code */
        `,
    };

    return (
        <>
            <StyledWrapper {...wrapperStyles}>
                <StyledWrapper {...overlayWrapperStyles}>
                    <StyledWrapper {...styles.contentWrapper}>
                        <Typography {...styles.title}>{page.fields.title}</Typography>
                    </StyledWrapper>
                </StyledWrapper>
            </StyledWrapper>
            <PageBreadcrumbs />
        </>
    );
};

const widgetModule: WidgetModule<FoundationFieldDefinition> = {
    component: connect(mapStateToProps)(BlogHeader),
    definition: {
        group: constants.widgetGroup.blogPage as any,
        allowedContexts: [constants.pageType.blogPost, constants.pageType.blogList, constants.pageType.blogHome] as any,
        fieldDefinitions: fieldDefinitionBuilder([
            {
                name: "positionX",
                displayName: "Position X (%)", // Store Custom Code
                defaultValue: 0,
                editorTemplate: "IntegerField",
                tooltip: "Position on the X axis",
                fieldType: "General",
                min: 0, // Store Custom Code
            },
            {
                name: "positionY",
                displayName: "Position Y (%)", // Store Custom Code
                defaultValue: 0,
                editorTemplate: "IntegerField",
                tooltip: "Position on the Y axis",
                fieldType: "General",
                min: 0, // Store Custom Code
            },
        ]),
    },
};

export default widgetModule;
